
/* ============ "Encuentra tu nuevo aroma" v3 — tarjetas glass, 7 notas ============ */
(function(){
  var grid=document.getElementById('xfGrid'); if(!grid) return;
  var chips=document.getElementById('xfChips'), results=document.getElementById('xfResults'),
      count=document.getElementById('xfCount'), more=document.getElementById('xfMore'), resetBtn=document.getElementById('xfReset'),
      genderWrap=document.getElementById('xfGender'), selFam=document.getElementById('xfFam'), selNote=document.getElementById('xfNote'),
      cards=[].slice.call(grid.querySelectorAll('.xf-card'));
  var CAT=window.VELANTIS_CAT||[];
  var NOTES=['citrico','floral','frutal','cuero','limpio','amaderado','dulce'];
  var TITLES={citrico:'Cítrico',floral:'Floral',frutal:'Frutal',cuero:'Cuero',limpio:'Limpio',amaderado:'Amaderado',dulce:'Dulce'};
  var selected=[], shown=12, fGender='', fFam='', fNote='', fSearch='';

  function de(s){return String(s).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();}
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function pyrTxt(r){return [r[5],r[6],r[7]].filter(Boolean).join(', ');}
  // Bancos de palabras clave por nota — leen la fragancia REAL (familia + salida/corazón/fondo)
  var KW={
    citrico:['citric','bergamot','limon','lima','naranj','mandarin','pomelo','toronj','yuzu','petitgrain','verbena','cidra','kumquat','hesperid','citron','clementina','neroli'],
    floral:['floral','flor','rosa','jazmin','azahar','iris','violeta','peonia','lirio','gardenia','tuberosa','muguete','muguet','ylang','magnolia','nardo','mimosa','fresia','freesia','geranio','loto','orquidea','heliotropo','osmanto','lavanda'],
    frutal:['frutal','manzana','pera','durazno','melocoton','frambuesa','fresa','pina','melon','lichi','grosell','ciruela','mora','chabacano','mango','cereza','membrillo','higo','uva','maracuya','guayaba','papaya','nectarina','arandano','coco','frutos rojos','ruibarbo','datil'],
    cuero:['cuero','gamuza','ante ','tabaco','suede','cuir'],
    limpio:['almizcle','musk','jabon','algodon','acuat','marino','aldehid','ozon','brisa','lluvia','fresco','limpio','menta','te blanco','lino','sal marina','notas marinas','aire'],
    amaderado:['amader','madera','cedro','sandalo','vetiver','pachul','oud','agarwood','guaiac','gaiac','roble','abedul','amberwood','ambroxan','incienso','olibano','papiro','cipres','pino','musgo','oakmoss','ebano','palo santo','haya'],
    dulce:['vainilla','caramelo','azucar','miel','chocolate','cacao','praline','malvavisco','tonka','benjui','toffee','dulce','azucarado','leche','crema','haba tonka','regaliz','melaza']
  };
  var STIDX={citrico:0,floral:1,amaderado:2,dulce:3,limpio:5}; // r[10]:[citr,flor,amad,vainilla,especiado,limpio]
  function hasKW(t,ks){ for(var i=0;i<ks.length;i++) if(t.indexOf(ks[i])>=0) return true; return false; }
  function cntKW(t,ks){ var n=0; for(var i=0;i<ks.length;i++) if(t.indexOf(ks[i])>=0) n++; return n; }
  function noteStrength(r,note){
    var ks=KW[note];
    var fam=de((r[3]||'')+' '+(r[4]||''));
    var sal=de(r[5]||''), cor=de(r[6]||''), fon=de(r[7]||'');
    var famM=hasKW(fam,ks)?1:0;                                              // familia = autoridad
    var pres=(hasKW(sal,ks)?0.44:0)+(hasKW(cor,ks)?0.34:0)+(hasKW(fon,ks)?0.30:0); // la ENTRADA pesa más
    var rich=Math.min(0.18,(cntKW(sal,ks)+cntKW(cor,ks)+cntKW(fon,ks))*0.035);
    var st=0; if(STIDX[note]!=null){ var d=parseInt((r[10]||'000000')[STIDX[note]]||'0',10)||0; st=Math.min(1,d/6); }
    return Math.max(0,Math.min(1, 0.5*famM + 0.42*Math.min(1,pres) + 0.28*st + rich));
  }
  function scores(r){
    if(r.__sc) return r.__sc;
    var sc={}; for(var i=0;i<NOTES.length;i++) sc[NOTES[i]]=noteStrength(r,NOTES[i]);
    r.__sc=sc; return sc;
  }
  var THRESH=0.30;                                                          // umbral: la fragancia "tiene" la nota
  function compat(r){
    if(!selected.length) return 0;
    var sc=scores(r), sum=0, minv=1;
    for(var j=0;j<selected.length;j++){ var v=sc[selected[j]]; sum+=v; if(v<minv) minv=v; }
    var avg=sum/selected.length;
    var s=(0.15+0.85*avg)*(minv>=THRESH?1:0.9);                             // 0..1, premia que TODAS sean fuertes
    return Math.max(0,Math.min(100,Math.round(s*100)));                     // SIEMPRE 0-100%
  }
  function anyFilter(){ return !!(fGender||fFam||fNote||fSearch); }
  // super específico: la fragancia debe tener TODAS las notas elegidas (lógica AND)
  function hasAll(r){ var sc=scores(r); for(var i=0;i<selected.length;i++){ if(sc[selected[i]]<THRESH) return false; } return true; }
  function matches(){
    return CAT.map(function(r){return {r:r,pct:compat(r)};})
      .filter(function(o){ var r=o.r;
        if(r[1]==='Ambiental') return false;   // los ambientales solo en su sección, no en el finder
        if(selected.length){ if(o.pct<=0||!hasAll(r)) return false; }   // con notas: lógica AND + %
        if(fSearch && de((r[0]||'')+' '+(r[2]||'')+' '+pyrTxt(r)+' '+(r[12]||'')).indexOf(fSearch)<0) return false; // buscador
        if(fGender && r[1]!==fGender) return false;
        if(fFam && r[4]!==fFam) return false;
        if(fNote && de(pyrTxt(r)).indexOf(de(fNote))<0) return false;
        return true; })
      .sort(function(a,b){return b.pct-a.pct || a.r[0].localeCompare(b.r[0],'es');});
  }
  function renderChips(){
    if(!selected.length){ chips.innerHTML='<span class="xf-hint">Selecciona tus notas favoritas para ver tus coincidencias</span>'; return; }
    chips.innerHTML='';
    selected.forEach(function(nm){
      var c=document.createElement('button'); c.className='xf-chip'; c.type='button';
      c.innerHTML=TITLES[nm]+' <span class="x">&times;</span>';
      c.addEventListener('click',function(){toggle(nm);});
      chips.appendChild(c);
    });
  }
  function renderResults(){
    if(!selected.length && !fSearch){ results.innerHTML=''; more.hidden=true; resetBtn.hidden=!anyFilter();
      count.textContent=anyFilter()?'Escribe algo o selecciona una nota para ver coincidencias':''; return; }
    resetBtn.hidden=false;
    var list=matches(), slice=list.slice(0,shown);
    count.textContent=list.length?(list.length+(selected.length?' fragancias coinciden con tu mezcla':' fragancias encontradas'))
      :'No hay coincidencias · ajusta la búsqueda, las notas o los filtros';
    results.innerHTML='';
    slice.forEach(function(o,idx){
      var r=o.r, card=document.createElement('article'); card.className='xf-rc'; card.setAttribute('data-name',r[0]); card.setAttribute('tabindex','0');
      card.setAttribute('data-price',(r[11]||389)); card.setAttribute('data-img','n-'+r[9]); card.setAttribute('data-sub',r[3]);
      card.style.animationDelay=((idx%12)*0.04)+'s';
      var C=2*Math.PI*26, off=C*(1-o.pct/100);
      var ringHTML = o.pct>0 ? ('<div class="xf-ring"><svg viewBox="0 0 60 60">'+
            '<circle cx="30" cy="30" r="26" fill="none" stroke="var(--line-2)" stroke-width="4"/>'+
            '<circle cx="30" cy="30" r="26" fill="none" stroke="var(--xf-gold)" stroke-width="4" stroke-linecap="round" '+
              'stroke-dasharray="'+C+'" stroke-dashoffset="'+off+'"/></svg>'+
            '<span class="pct">'+o.pct+'%</span></div>') : '';
      card.innerHTML=
        '<div class="xf-rc-img n-'+esc(r[9])+'"></div>'+
        '<div class="xf-rc-main">'+ ringHTML +
          '<div class="xf-info"><p class="fam">'+esc(r[3])+'</p><h4>'+esc(r[0])+'</h4>'+
            '<span class="xf-gender">'+esc(r[1])+'</span>'+
            (r[2]?'<p>Inspirado en · '+esc(r[2])+'</p>':'')+
            '<div class="pr">'+(r[1]==='Ambiental'?('$'+(r[11]||449)+' MXN'):('$'+(r[11]||590)+' MXN'))+'</div>'+
            '<button class="add" type="button">Agregar al carrito</button></div>'+
        '</div>';
      results.appendChild(card);
    });
    more.hidden = slice.length>=list.length;
  }
  function toggle(n){
    var i=selected.indexOf(n);
    if(i>=0) selected.splice(i,1); else selected.push(n);
    cards.forEach(function(c){ c.classList.toggle('sel',selected.indexOf(c.dataset.note)>=0); });
    shown=12; renderChips(); renderResults();
  }
  grid.addEventListener('click',function(e){ var c=e.target.closest('.xf-card'); if(c) toggle(c.dataset.note); });
  grid.addEventListener('keydown',function(e){ if(e.key!=='Enter'&&e.key!==' ')return; var c=e.target.closest('.xf-card'); if(c){ e.preventDefault(); toggle(c.dataset.note); } });

  more.addEventListener('click',function(){ shown+=12; renderResults(); });
  resetBtn.addEventListener('click',function(){
    selected=[]; shown=12; fGender=''; fFam=''; fNote='';
    cards.forEach(function(c){c.classList.remove('sel');});
    if(genderWrap){ [].forEach.call(genderWrap.children,function(c){c.classList.toggle('on',!c.dataset.g);}); }
    if(selFam) selFam.value=''; if(selNote) selNote.value='';
    renderChips(); renderResults();
  });
  if(genderWrap) genderWrap.addEventListener('click',function(e){
    var b=e.target.closest('.xf-fchip'); if(!b) return;
    [].forEach.call(genderWrap.children,function(c){c.classList.remove('on');});
    b.classList.add('on'); fGender=b.dataset.g||''; shown=12; renderResults();
  });
  if(selFam) selFam.addEventListener('change',function(){ fFam=selFam.value; shown=12; renderResults(); });
  if(selNote) selNote.addEventListener('change',function(){ fNote=selNote.value; shown=12; renderResults(); });

  // buscador (nombre / casa / nota) — insertado bajo la grilla de notas
  var xfSearch=document.createElement('input');
  xfSearch.type='search'; xfSearch.id='xfSearch'; xfSearch.className='xf-search';
  xfSearch.placeholder='Buscar por nombre, casa, nota o código…'; xfSearch.setAttribute('aria-label','Buscar fragancia');
  if(grid&&grid.parentNode){ grid.parentNode.insertBefore(xfSearch, grid.nextSibling); }
  var _st; xfSearch.addEventListener('input',function(){ clearTimeout(_st); _st=setTimeout(function(){ fSearch=de(xfSearch.value.trim()); shown=12; renderResults(); },120); });

  renderChips(); renderResults();
})();
